import services from './../../../services/service'; // Service Class
import AccountResources from './../../Account/Resources/commonfunctions.js';
import MainHeader from './../../MainHeader/index.vue'; // Main Header

//
let service = new services();

export default {
    name: 'ManageOrders',
    mixins: [AccountResources],
    data () {
        return {
            headerdata:{'name':this.$route.name},
            users: {},
            user: {},
            business: {},
            sellpoints:{},
            categories: {},
            market_categories: {},
            market_groups: {},
            states: {},
            cities: {},
            disable_btn: false,
            validate_user_name_error:false,
            group_isset:false,
            add_sellpoint: false,
            add_business: false,
            get_flag:false,
            loading:false,
            action_loading:false,

            //messages
            validate_user_name_message: "",
            payment_successful_message:"",
            data_error_message: "",
            data_boarding_message: "",

            //
            headerdata:{
                'name':'Set Order',
            },

            //
            reset_order:false,
            set_inner_view:'',
            set_page_routes:[
                {n:0,view:'', name: 'Settings',path:'/settings',showHeader:1,showBack:0},
                {n:1,view:'',name:'Profile',path: '/settings/profile',showHeader:1,showBack:0},
                {n:2,view:'setProfileDetails',name:'Profile Settings',path: '/settings/set/profile',showHeader:0,showBack:1},
                {n:3,view:'setContactInformation',name:'Edit Profile',path: '/settings/edit/profile',showHeader:0,showBack:1},
                {n:4,view:'setDeliveryLocations',name:'Delivery Locations',path:'/settings/deliverylocations',showHeader:0,showBack:1},
                {n:5,view:'setBusinessDetails',name:'Business Details',path:'/settings/business/details',showHeader:0,showBack:1},
                {n:6,view:'setEditBusinessDetails',name:'Edit Business Details',path:'/settings/business/edit/details',showHeader:0,showBack:1},
                {n:7,view:'setBusinessDisplayPhoto',name:'Business Photos',path:'/settings/business/display/photos',showHeader:0,showBack:1},
                //{n:0,view:'setBusinessLocation',name:'Business Location',path:'/settings/business/location',showHeader:0,showBack:1},
                {n:8,view:'setBusinessDeliveryLocations',name:'Buiness Delivery Locations',path:'/settings/businessdeliverylocations',showHeader:0,showBack:1},
                {n:9,view:'setBankInformation',name:'Bank Information',path:'/settings/bankinformation',showHeader:0,showBack:1},
                {n:10,view:'setResetPassword',name:'Reset Password',path:'/settings/resetpassword',showHeader:0,showBack:1},
            ],

        }
    },
    components: {'component-header':MainHeader},
    
    methods: {

        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },

        resetMessages(){
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },

        preset() {
            this.loading = true;
            //../
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user = value;
                    //check for user's business
                    self.getSellpoints(self.user.user_id);
                    self.setPageSettings();
                    self.setUserForEdit();
                }else {
                    self.loading = false;
                    self.$router.push('/login');
                }

                //
                self.getUser(); //re-call
            });
        },

        setBusinessDetailsAA(){
            //---bank-details
            let self = this;
            localforage.getItem(service.bbnksdb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {console.log(7654999)
                    self.sellpoint.business_bank_details = value;
                    self.business_bank_details = value;
                }
                self.loading = false;
            });
            //--delivery-locations
            localforage.getItem(service.bbdlsdb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.sellpoint.business_delivery_options = value;
                    self.business_delivery_locations = value;
                }
                self.loading = false;
            });

            ///get/reset business-----set func at common...
            this.getSellpointDetails();
            ///--business
            ///banks
            //delivery locations
        },

        setUserForEdit(){
            this.data_user.user_name = this.user.user_name;
            this.data_user.user_phone = this.user.user_phone;
            this.data_user.user_email = this.user.user_email;
        },

        setPageSettings(){},

        prepSetView(set_to_view,set_back_view){
            let view_type = 3; //default // set_inner_view
            let nav_to_view = '';
            let nav_to_url = '';
            let nav_back_view = '';
            let nav_back_url = '';

            //
            nav_to_view = this.set_page_routes[set_to_view].view;
            nav_to_url = this.set_page_routes[set_to_view].path;
            nav_back_view = this.set_inner_view; //this.set_page_routes[set_back_view].view;
            nav_back_url = this.$route.path; //this.set_page_routes[set_back_view].path;
            // nav_to_header = this.set_page_routes[set_to_view].showHeader;
           
            //
            let params = {
                type:view_type,
                nav_to_view:nav_to_view,
                nav_to_url:nav_to_url,
                //nav_to_header: nav_to_header,
                nav_back_view:nav_back_view,
                nav_back_url:nav_back_url,
                //nav_back_header: nav_back_header
            }
            //
            this.setNavView(params);
        }

    },

    created: function(){
        this.callBackNav();
        this.setScreenView();
        this.setPageView(3,this.$route.path);
        //
        this.preset();
        //
        if(this.$route.path == "/settings/profile"){
            this.setMenuTabInnerView('setProfile');
            if((this.site_view == 2)){
                this.set_inner_view = "setProfileDetails";
                //this.set_show_back = false;
            }
            this.$router.push('/settings/set/profile'); //reset actual url for settings
        }
        //
        this.getRavepayBanks();
    }
}



// WEBPACK FOOTER //
// ./src/pages/Components/SettingsManagement/script.js